/* eslint-disable max-len */
import React, {useState} from 'react';
import axios from 'axios';
import {useNavigate} from 'react-router-dom';
import {useForm} from 'react-hook-form';
import {ErrorMessage} from '@hookform/error-message';
import {Form} from 'react-bootstrap';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import './styles.css';
import {Toast} from './SweetAlert';

/* eslint "require-jsdoc": [2, {
    "require": {
        "FunctionDeclaration": true,
        "MethodDefinition": false,
        "ClassDeclaration": false
    }
}]*/
/**
* @return {html} Register Page.
  */
function Register() {
  const {handleSubmit, register, formState: {errors}} = useForm();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const onSubmit = (data) => {
    Toast.fire({
      icon: 'loading',
      title: 'Registration in progress...',
    });
    axios.post(`https://blooming-springs-86289.herokuapp.com/api/member/`, {
      first_name: data.first_name,
      last_name: data.last_name,
      email: data.email,
      password: data.password,
      tier: 'Bronze',
      points: 0,
      accumulated_points: 0,
    })
        .then((response) => {
          Toast.fire({
            icon: 'success',
            title: 'You have registered. Redirecting...',
          });
          navigate('/');
        })

        .catch((err) => {
          if (err.response?.status == 500) {
            Toast.fire({
              icon: 'error',
              title: 'Error!',
              text: 'This is a system error.Please try again later.',
            });
          }
          if (err.response?.status == 405) {
            Toast.fire({
              icon: 'error',
              title: 'Error!',
              text: 'An account is linked to this email, please login instead.',
            });
          }
          if (err.response?.status == 400) {
            Toast.fire({
              icon: 'error',
              title: 'Error!',
              text: 'Invalid email entered',
            });
          }
        });
  };
  return (
    <div className="background">
      <h2 className='header'>Burger Lab</h2>
      <Form className="register-form" noValidate onSubmit={handleSubmit(onSubmit)}>
        <Box
          sx={{
            'mx': 'auto',
            'width': 400,
            'display': 'flex',
            'flexDirection': 'column',
            '& .MuiTextField-root': {width: '46ch'},
          }}>
          <div id="title">Register</div>
          <div id="firstName">
            <TextField type="first_name" label={'First Name'}
              id="margin-none"
              {...register('first_name', {required: 'First Name is required'})}
            />
            <ErrorMessage
              errors={errors}
              name="first_name"
              render={({message}) => <div id="message">{message}</div>} />
          </div>
          <div id="lastName">
            <TextField type="last_name" label={'Last Name'}
              id="margin-none"
              {...register('last_name', {required: 'Last Name is required'})} />
            <ErrorMessage
              errors={errors}
              name="last_name"
              render={({message}) => <div id="message">{message}</div>} />
          </div>
          <div id="email">
            <TextField type="email" label={'Email'} id="margin-none" className="email-input" value={email}

              {...register('email', {required: 'Email is required'})} onChange={(e) => setEmail(e.target.value)} />
            <ErrorMessage
              errors={errors}
              name="email"
              render={({message}) => <div id="message">{message}</div>} />
          </div>

          <div className="password">
            <TextField type="password" label={'Password'}
              id="margin-none" value={password}
              {...register('password', {required: 'Password is required'})} onChange={(e) => setPassword(e.target.value)} />
            <ErrorMessage
              errors={errors}
              name="password"
              render={({message}) => <div id="message">{message}</div>}
            />
          </div>
          <Button variant="contained" type="submit"
            id="register" >Register</Button>
          <div id="or">OR</div>
          <Button variant="contained" id="login"
            onClick={() => navigate('/')} >Login</Button>
        </Box>
      </Form>
    </div>
  );
}


export default Register;
